import {
  authReducer,
  appMasterReducer,
  userMasterReducer,
  menuMasterReducer,
  adminMasterReducer,
  clientMasterReducer,
  appClientMappingReducer,
  userMenuMappingReducer,
} from "./state/index.js"
import {
  FLUSH,
  PAUSE,
  PURGE,
  PERSIST,
  REGISTER,
  REHYDRATE,
  persistStore,
} from "redux-persist"
import "./index.css"
import App from "./App"
import React from "react"
import { Provider } from "react-redux"
import ReactDOM from "react-dom/client"
import { CombinedContext } from "./context"
import storage from "redux-persist/lib/storage"
import { BrowserRouter } from "react-router-dom"
import { configureStore } from "@reduxjs/toolkit"
import { PersistGate } from "redux-persist/integration/react"
import { encryptTransform } from "redux-persist-transform-encrypt"
import persistCombineReducers from "redux-persist/es/persistCombineReducers"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { NextUIProvider } from "@nextui-org/react"

const queryClient = new QueryClient()

const presistConfig = {
  key: "root",
  storage,
  version: 1,
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_SECRET_KEY,
      onError: function (error) {},
    }),
  ],
}
const persistedReducer = persistCombineReducers(presistConfig, {
  clientMaster: clientMasterReducer,
  userMaster: userMasterReducer,
  adminMaster: adminMasterReducer,
  auth: authReducer,
  appMaster: appMasterReducer,
  appClientMapping: appClientMappingReducer,
  menuMaster: menuMasterReducer,
  userMenuMapping: userMenuMappingReducer,
})
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})
export const persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <CombinedContext>
            <QueryClientProvider client={queryClient}>
              <NextUIProvider>
                <App />
              </NextUIProvider>
            </QueryClientProvider>
          </CombinedContext>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
)
